
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export const useProductName = (productId: string | undefined) => {
  const [productName, setProductName] = useState<string>("");

  useEffect(() => {
    const fetchProductName = async () => {
      if (productId) {
        const { data, error } = await supabase
          .from('products')
          .select('name')
          .eq('id', productId)
          .single();
        
        if (!error && data) {
          setProductName(data.name);
        }
      }
    };
    fetchProductName();
  }, [productId]);

  return productName;
};
